import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';

/**
 * AG Grid module registration — import once for its side effect (done in
 * `src/main.tsx`, mirroring gpm-webapp-v2's `agGridModules.ts` pattern).
 *
 * gpm-ui's `DataGrid` also passes `AllCommunityModule` per instance, but
 * registering globally (a) keeps any direct `AgGridReact` usage working and
 * (b) guarantees registration happens against OUR ag-grid copy — the one
 * `resolve.dedupe` in vite.config.ts forces gpm-ui to share. reipm's grids are
 * simple server-driven lists, so the whole community bundle is fine; switch to
 * gpm-webapp's granular module lists only if bundle size ever becomes a concern.
 */
ModuleRegistry.registerModules([AllCommunityModule]);

export const agGridModulesRegistered = true;
